import React, { Component, Fragment } from 'react';
import { format } from 'date-fns';
import I18n from '~/utils/translations';

export default class AddToCalendarButton extends Component {
  render() {
    return (
      <Fragment>
        <div className="add-to-calendar">
          <a className="add-to-calendar__button" onClick={this.downloadCalendarEvent}>
            + {I18n.t('viewings.add_to_other_calendar')}
          </a>
        </div>
      </Fragment>
    );
  }

  downloadCalendarEvent = (e) => {
    e.preventDefault();
    const filename = 'residently_viewing.ics';
    const blob = new Blob([this.createIcalEvent()], { type: 'text/calendar;charset=utf-8' });

    if (this.isInternetExplorer()) {
      window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  formatDate(date) {
    return format(date, "yyyyMMdd'T'HHmmss");
  }

  createIcalEvent() {
    const formattedStart = this.formatDate(new Date(this.props.viewingStart));
    const formattedEnd = this.formatDate(new Date(this.props.viewingEnd));
    let icalText = 'BEGIN:VCALENDAR\n';
    icalText += 'VERSION:2.0\n';
    icalText += 'CALSCALE:GREGORIAN\n';
    icalText += 'METHOD:PUBLISH\n';
    icalText += 'X-PUBLISHED-TTL:PT1H\n';
    icalText += 'BEGIN:VEVENT\n';
    icalText += `UID:${new Date().getTime()}\n`;
    icalText += `SUMMARY:${I18n.t('viewings.calendar_title', { headline: this.props.headline })}\n`;
    icalText += `DESCRIPTION: ${window.location}\n`;
    icalText += `DTSTAMP:${this.formatDate(new Date())}\n`;
    icalText += `DTSTART:${formattedStart}\n`;

    if (this.props.viewingEnd) {
      icalText += `DTEND:${formattedEnd}\n`;
    } else {
      icalText += 'DURATION:PT30M\n';
    }

    icalText += `LOCATION:${this.props.location}\n`;
    icalText += 'END:VEVENT\n';
    icalText += 'END:VCALENDAR\n';

    return icalText;
  }

  isInternetExplorer() {
    return /MSIE/.test(window.navigator.userAgent) || /Trident/.test(window.navigator.userAgent);
  }
}
